//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './AppointmentEventsClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type SearchVisitsAppointmentEventsQueryParameters = {
  patientId?: number | null | undefined ;
  caseId?: number | null | undefined ;
  importIds?: string[] | null | undefined ;
  number?: string[] | null | undefined ;
  from?: Date | null | undefined ;
  to?: Date | null | undefined ;
  subtenants?: number[] | null | undefined ;
  isWaitingList?: boolean | undefined ;
  values?: { [key: string]: string[]; } | null | undefined ;
  includeValues?: boolean | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
}

export type UpdateVisitAppointmentEventsQueryParameters = {
  id: number ;
}

export type GetVisitAppointmentEventsQueryParameters = {
  id: number ;
}

export type DeleteAppointmentAppointmentEventsQueryParameters = {
  id: number ;
}

export type SearchAppointmentsAppointmentEventsQueryParameters = {
  id?: number | null | undefined ;
  ids?: number[] | null | undefined ;
  from?: Date | null | undefined ;
  to?: Date | null | undefined ;
  eventTypes?: Types.AppointmentType[] | null | undefined ;
  subtenants?: number[] | null | undefined ;
  tags?: number[] | null | undefined ;
  visitTypes?: number[] | null | undefined ;
  patients?: number[] | null | undefined ;
  visitStatuses?: Types.AppointmentStatusCodes[] | null | undefined ;
  resourceIds?: number[] | null | undefined ;
  placesIds?: number[] | null | undefined ;
  specialConditionsIds?: number[] | null | undefined ;
  doctorIds?: number[] | null | undefined ;
  isWithoutResources?: boolean | null | undefined ;
  isWithoutCanceledVisits?: boolean | undefined ;
  isWaitingList?: boolean | undefined ;
  queries?: Types.JsQuery[] | null | undefined ;
  values?: { [key: string]: string[]; } | null | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
}

export type SearchAppointmentsWithResourceOccupationAppointmentEventsQueryParameters = {
  id?: number | null | undefined ;
  ids?: number[] | null | undefined ;
  from?: Date | null | undefined ;
  to?: Date | null | undefined ;
  eventTypes?: Types.AppointmentType[] | null | undefined ;
  subtenants?: number[] | null | undefined ;
  tags?: number[] | null | undefined ;
  visitTypes?: number[] | null | undefined ;
  patients?: number[] | null | undefined ;
  visitStatuses?: Types.AppointmentStatusCodes[] | null | undefined ;
  resourceIds?: number[] | null | undefined ;
  placesIds?: number[] | null | undefined ;
  specialConditionsIds?: number[] | null | undefined ;
  doctorIds?: number[] | null | undefined ;
  isWithoutResources?: boolean | null | undefined ;
  isWithoutCanceledVisits?: boolean | undefined ;
  isWaitingList?: boolean | undefined ;
  queries?: Types.JsQuery[] | null | undefined ;
  values?: { [key: string]: string[]; } | null | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
}

export type CancelVisitAppointmentEventsQueryParameters = {
  id: number ;
}

export type ConfirmVisitAppointmentEventsQueryParameters = {
  id: number ;
}

export type CompleteVisitAppointmentEventsQueryParameters = {
  id: number ;
}

export type FindFreeTimeSlotAppointmentEventsQueryParameters = {
  patientId?: number | undefined ;
  visitTypeId?: number | undefined ;
  start?: Date | undefined ;
  durationInSeconds?: number | undefined ;
  timeStepInSeconds?: number | undefined ;
  searchDirection?: Types.SearchDirection | undefined ;
  skipCurrentDay?: boolean | undefined ;
  isParticularTime?: boolean | undefined ;
  searchIntervalForwardInDays?: number | undefined ;
  searchIntervalBackwardInDays?: number | undefined ;
  visitId?: number | null | undefined ;
  resourceIds?: number[] | null | undefined ;
}

export type GetAbsenceAppointmentEventsQueryParameters = {
  id: number ;
}

export type PatchAbsenceAppointmentEventsQueryParameters = {
  id: number ;
}

export function createVisitUrl(): string {
  let url_ = getBaseUrl() + "/api/appointments/visits";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createVisitMutationKey(): MutationKey {
  return trimArrayEnd([
      'AppointmentEventsClient',
      'createVisit',
    ]);
}

export function useCreateVisitMutation<TContext>(options?: Omit<UseMutationOptions<Types.VisitDto, unknown, Types.CreateVisitDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.VisitDto, unknown, Types.CreateVisitDto, TContext> {
  const key = createVisitMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (createVisitDto: Types.CreateVisitDto) => Client.createVisit(createVisitDto),
    mutationKey: key,
  });
}
  
export function searchVisitsUrl(patientId?: number | null | undefined, caseId?: number | null | undefined, importIds?: string[] | null | undefined, number?: string[] | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, subtenants?: number[] | null | undefined, isWaitingList?: boolean | undefined, values?: { [key: string]: string[]; } | null | undefined, includeValues?: boolean | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/appointments/visits?";
if (patientId !== undefined && patientId !== null)
    url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
if (caseId !== undefined && caseId !== null)
    url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
if (importIds !== undefined && importIds !== null)
    importIds && importIds.forEach(item => { url_ += "ImportIds=" + encodeURIComponent("" + item) + "&"; });
if (number !== undefined && number !== null)
    number && number.forEach(item => { url_ += "Number=" + encodeURIComponent("" + item) + "&"; });
if (from !== undefined && from !== null)
    url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
if (to !== undefined && to !== null)
    url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
if (subtenants !== undefined && subtenants !== null)
    subtenants && subtenants.forEach(item => { url_ += "Subtenants=" + encodeURIComponent("" + item) + "&"; });
if (isWaitingList === null)
    throw new Error("The parameter 'isWaitingList' cannot be null.");
else if (isWaitingList !== undefined)
    url_ += "IsWaitingList=" + encodeURIComponent("" + isWaitingList) + "&";
if (values !== undefined && values !== null)
    values && Object.keys(values).forEach(key => { url_ += encodeURIComponent(key) +"=" + encodeURIComponent("" + values[key]) + "&"; });
if (includeValues === null)
    throw new Error("The parameter 'includeValues' cannot be null.");
else if (includeValues !== undefined)
    url_ += "IncludeValues=" + encodeURIComponent("" + includeValues) + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let searchVisitsDefaultOptions: Omit<UseQueryOptions<Types.VisitListDto[], unknown, Types.VisitListDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.VisitListDto[], unknown, Types.VisitListDto[]>, 'queryFn'>> = {
};
export function getSearchVisitsDefaultOptions() {
  return searchVisitsDefaultOptions;
};
export function setSearchVisitsDefaultOptions(options: typeof searchVisitsDefaultOptions) {
  searchVisitsDefaultOptions = options;
}

export function searchVisitsQueryKey(dto: SearchVisitsAppointmentEventsQueryParameters): QueryKey;
export function searchVisitsQueryKey(patientId?: number | null | undefined, caseId?: number | null | undefined, importIds?: string[] | null | undefined, number?: string[] | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, subtenants?: number[] | null | undefined, isWaitingList?: boolean | undefined, values?: { [key: string]: string[]; } | null | undefined, includeValues?: boolean | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function searchVisitsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { patientId, caseId, importIds, number, from, to, subtenants, isWaitingList, values, includeValues, offset, limit, sortBy, sortOrder,  } = params[0] as SearchVisitsAppointmentEventsQueryParameters;

    return trimArrayEnd([
        'AppointmentEventsClient',
        'searchVisits',
        patientId as any,
        caseId as any,
        importIds as any,
        number as any,
        from as any,
        to as any,
        subtenants as any,
        isWaitingList as any,
        values as any,
        includeValues as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'AppointmentEventsClient',
        'searchVisits',
        ...params
      ]);
  }
}
export function __searchVisits(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.searchVisits(
      context.queryKey[2] as number | null | undefined,       context.queryKey[3] as number | null | undefined,       context.queryKey[4] as string[] | null | undefined,       context.queryKey[5] as string[] | null | undefined,       context.queryKey[6] as Date | null | undefined,       context.queryKey[7] as Date | null | undefined,       context.queryKey[8] as number[] | null | undefined,       context.queryKey[9] as boolean | undefined,       context.queryKey[10] as { [key: string]: string[]; } | null | undefined,       context.queryKey[11] as boolean | undefined,       context.queryKey[12] as number | null | undefined,       context.queryKey[13] as number | null | undefined,       context.queryKey[14] as string | null | undefined,       context.queryKey[15] as Types.SortOrder | undefined,axiosConfig    );
}

export function useSearchVisitsQuery<TSelectData = Types.VisitListDto[], TError = unknown>(dto: SearchVisitsAppointmentEventsQueryParameters, options?: Omit<UseQueryOptions<Types.VisitListDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param patientId (optional) 
 * @param caseId (optional) 
 * @param importIds (optional) 
 * @param number (optional) 
 * @param from (optional) 
 * @param to (optional) 
 * @param subtenants (optional) 
 * @param isWaitingList (optional) If true, only visits from waiting list are included
If false, visits from waiting list are excluded
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param includeValues (optional) If this flag is true, response DTO contains Values.
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useSearchVisitsQuery<TSelectData = Types.VisitListDto[], TError = unknown>(patientId?: number | null | undefined, caseId?: number | null | undefined, importIds?: string[] | null | undefined, number?: string[] | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, subtenants?: number[] | null | undefined, isWaitingList?: boolean | undefined, values?: { [key: string]: string[]; } | null | undefined, includeValues?: boolean | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: Omit<UseQueryOptions<Types.VisitListDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useSearchVisitsQuery<TSelectData = Types.VisitListDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.VisitListDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let patientId: any = undefined;
  let caseId: any = undefined;
  let importIds: any = undefined;
  let number: any = undefined;
  let from: any = undefined;
  let to: any = undefined;
  let subtenants: any = undefined;
  let isWaitingList: any = undefined;
  let values: any = undefined;
  let includeValues: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ patientId, caseId, importIds, number, from, to, subtenants, isWaitingList, values, includeValues, offset, limit, sortBy, sortOrder,  } = params[0] as SearchVisitsAppointmentEventsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [patientId, caseId, importIds, number, from, to, subtenants, isWaitingList, values, includeValues, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.VisitListDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __searchVisits(context, axiosConfig) : __searchVisits,
    queryKey: searchVisitsQueryKey(patientId, caseId, importIds, number, from, to, subtenants, isWaitingList, values, includeValues, offset, limit, sortBy, sortOrder),
    ...searchVisitsDefaultOptions as unknown as Omit<UseQueryOptions<Types.VisitListDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param patientId (optional) 
 * @param caseId (optional) 
 * @param importIds (optional) 
 * @param number (optional) 
 * @param from (optional) 
 * @param to (optional) 
 * @param subtenants (optional) 
 * @param isWaitingList (optional) If true, only visits from waiting list are included
If false, visits from waiting list are excluded
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param includeValues (optional) If this flag is true, response DTO contains Values.
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setSearchVisitsData(queryClient: QueryClient, updater: (data: Types.VisitListDto[] | undefined) => Types.VisitListDto[], patientId?: number | null | undefined, caseId?: number | null | undefined, importIds?: string[] | null | undefined, number?: string[] | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, subtenants?: number[] | null | undefined, isWaitingList?: boolean | undefined, values?: { [key: string]: string[]; } | null | undefined, includeValues?: boolean | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(searchVisitsQueryKey(patientId, caseId, importIds, number, from, to, subtenants, isWaitingList, values, includeValues, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * @param patientId (optional) 
 * @param caseId (optional) 
 * @param importIds (optional) 
 * @param number (optional) 
 * @param from (optional) 
 * @param to (optional) 
 * @param subtenants (optional) 
 * @param isWaitingList (optional) If true, only visits from waiting list are included
If false, visits from waiting list are excluded
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param includeValues (optional) If this flag is true, response DTO contains Values.
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setSearchVisitsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.VisitListDto[] | undefined) => Types.VisitListDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function updateVisitUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/appointments/visits/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function updateVisitMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'AppointmentEventsClient',
      'updateVisit',
      id as any,
    ]);
}

export function useUpdateVisitMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.VisitDto, unknown, Types.PatchVisitDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.VisitDto, unknown, Types.PatchVisitDto, TContext> {
  const key = updateVisitMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (patchDto: Types.PatchVisitDto) => Client.updateVisit(id, patchDto),
    mutationKey: key,
  });
}
  
type UpdateVisit__MutationParameters = UpdateVisitAppointmentEventsQueryParameters & {
  patchDto: Types.PatchVisitDto;
}

export function useUpdateVisitMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.VisitDto, unknown, UpdateVisit__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: UpdateVisitAppointmentEventsQueryParameters}): UseMutationResult<Types.VisitDto, unknown, UpdateVisit__MutationParameters, TContext> {
  const key = updateVisitMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: UpdateVisit__MutationParameters) => Client.updateVisit(data.id ?? options?.parameters?.id!, data.patchDto),
  mutationKey: key,
});
}
  
export function getVisitUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/appointments/visits/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getVisitDefaultOptions: Omit<UseQueryOptions<Types.VisitDto, unknown, Types.VisitDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.VisitDto, unknown, Types.VisitDto>, 'queryFn'>> = {
};
export function getGetVisitDefaultOptions() {
  return getVisitDefaultOptions;
};
export function setGetVisitDefaultOptions(options: typeof getVisitDefaultOptions) {
  getVisitDefaultOptions = options;
}

export function getVisitQueryKey(id: number): QueryKey;
export function getVisitQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetVisitAppointmentEventsQueryParameters;

    return trimArrayEnd([
        'AppointmentEventsClient',
        'getVisit',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'AppointmentEventsClient',
        'getVisit',
        ...params
      ]);
  }
}
export function __getVisit(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getVisit(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetVisitQuery<TSelectData = Types.VisitDto, TError = unknown>(dto: GetVisitAppointmentEventsQueryParameters, options?: Omit<UseQueryOptions<Types.VisitDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetVisitQuery<TSelectData = Types.VisitDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.VisitDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetVisitQuery<TSelectData = Types.VisitDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.VisitDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetVisitAppointmentEventsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.VisitDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getVisit(context, axiosConfig) : __getVisit,
    queryKey: getVisitQueryKey(id),
    ...getVisitDefaultOptions as unknown as Omit<UseQueryOptions<Types.VisitDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetVisitData(queryClient: QueryClient, updater: (data: Types.VisitDto | undefined) => Types.VisitDto, id: number) {
  queryClient.setQueryData(getVisitQueryKey(id),
    updater
  );
}

export function setGetVisitDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.VisitDto | undefined) => Types.VisitDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function deleteAppointmentUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/appointments/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deleteAppointmentMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'AppointmentEventsClient',
      'deleteAppointment',
      id as any,
    ]);
}

export function useDeleteAppointmentMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = deleteAppointmentMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.deleteAppointment(id),
    mutationKey: key,
  });
}
  
type DeleteAppointment__MutationParameters = DeleteAppointmentAppointmentEventsQueryParameters

export function useDeleteAppointmentMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, DeleteAppointment__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: DeleteAppointmentAppointmentEventsQueryParameters}): UseMutationResult<void, unknown, DeleteAppointment__MutationParameters, TContext> {
  const key = deleteAppointmentMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: DeleteAppointment__MutationParameters) => Client.deleteAppointment(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function searchAppointmentsUrl(id?: number | null | undefined, ids?: number[] | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, eventTypes?: Types.AppointmentType[] | null | undefined, subtenants?: number[] | null | undefined, tags?: number[] | null | undefined, visitTypes?: number[] | null | undefined, patients?: number[] | null | undefined, visitStatuses?: Types.AppointmentStatusCodes[] | null | undefined, resourceIds?: number[] | null | undefined, placesIds?: number[] | null | undefined, specialConditionsIds?: number[] | null | undefined, doctorIds?: number[] | null | undefined, isWithoutResources?: boolean | null | undefined, isWithoutCanceledVisits?: boolean | undefined, isWaitingList?: boolean | undefined, queries?: Types.JsQuery[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/appointments?";
if (id !== undefined && id !== null)
    url_ += "Id=" + encodeURIComponent("" + id) + "&";
if (ids !== undefined && ids !== null)
    ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
if (from !== undefined && from !== null)
    url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
if (to !== undefined && to !== null)
    url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
if (eventTypes !== undefined && eventTypes !== null)
    eventTypes && eventTypes.forEach(item => { url_ += "EventTypes=" + encodeURIComponent("" + item) + "&"; });
if (subtenants !== undefined && subtenants !== null)
    subtenants && subtenants.forEach(item => { url_ += "Subtenants=" + encodeURIComponent("" + item) + "&"; });
if (tags !== undefined && tags !== null)
    tags && tags.forEach(item => { url_ += "Tags=" + encodeURIComponent("" + item) + "&"; });
if (visitTypes !== undefined && visitTypes !== null)
    visitTypes && visitTypes.forEach(item => { url_ += "VisitTypes=" + encodeURIComponent("" + item) + "&"; });
if (patients !== undefined && patients !== null)
    patients && patients.forEach(item => { url_ += "Patients=" + encodeURIComponent("" + item) + "&"; });
if (visitStatuses !== undefined && visitStatuses !== null)
    visitStatuses && visitStatuses.forEach(item => { url_ += "VisitStatuses=" + encodeURIComponent("" + item) + "&"; });
if (resourceIds !== undefined && resourceIds !== null)
    resourceIds && resourceIds.forEach(item => { url_ += "ResourceIds=" + encodeURIComponent("" + item) + "&"; });
if (placesIds !== undefined && placesIds !== null)
    placesIds && placesIds.forEach(item => { url_ += "PlacesIds=" + encodeURIComponent("" + item) + "&"; });
if (specialConditionsIds !== undefined && specialConditionsIds !== null)
    specialConditionsIds && specialConditionsIds.forEach(item => { url_ += "SpecialConditionsIds=" + encodeURIComponent("" + item) + "&"; });
if (doctorIds !== undefined && doctorIds !== null)
    doctorIds && doctorIds.forEach(item => { url_ += "DoctorIds=" + encodeURIComponent("" + item) + "&"; });
if (isWithoutResources !== undefined && isWithoutResources !== null)
    url_ += "IsWithoutResources=" + encodeURIComponent("" + isWithoutResources) + "&";
if (isWithoutCanceledVisits === null)
    throw new Error("The parameter 'isWithoutCanceledVisits' cannot be null.");
else if (isWithoutCanceledVisits !== undefined)
    url_ += "IsWithoutCanceledVisits=" + encodeURIComponent("" + isWithoutCanceledVisits) + "&";
if (isWaitingList === null)
    throw new Error("The parameter 'isWaitingList' cannot be null.");
else if (isWaitingList !== undefined)
    url_ += "IsWaitingList=" + encodeURIComponent("" + isWaitingList) + "&";
if (queries !== undefined && queries !== null)
    queries && queries.forEach((item, index) => {
        for (let attr in item)
			if (item.hasOwnProperty(attr)) {
				url_ += "Queries[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
			}
    });
if (values !== undefined && values !== null)
    values && Object.keys(values).forEach(key => { url_ += encodeURIComponent(key) +"=" + encodeURIComponent("" + values[key]) + "&"; });
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let searchAppointmentsDefaultOptions: Omit<UseQueryOptions<Types.AppointmentEventDto[], unknown, Types.AppointmentEventDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.AppointmentEventDto[], unknown, Types.AppointmentEventDto[]>, 'queryFn'>> = {
};
export function getSearchAppointmentsDefaultOptions() {
  return searchAppointmentsDefaultOptions;
};
export function setSearchAppointmentsDefaultOptions(options: typeof searchAppointmentsDefaultOptions) {
  searchAppointmentsDefaultOptions = options;
}

export function searchAppointmentsQueryKey(dto: SearchAppointmentsAppointmentEventsQueryParameters): QueryKey;
export function searchAppointmentsQueryKey(id?: number | null | undefined, ids?: number[] | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, eventTypes?: Types.AppointmentType[] | null | undefined, subtenants?: number[] | null | undefined, tags?: number[] | null | undefined, visitTypes?: number[] | null | undefined, patients?: number[] | null | undefined, visitStatuses?: Types.AppointmentStatusCodes[] | null | undefined, resourceIds?: number[] | null | undefined, placesIds?: number[] | null | undefined, specialConditionsIds?: number[] | null | undefined, doctorIds?: number[] | null | undefined, isWithoutResources?: boolean | null | undefined, isWithoutCanceledVisits?: boolean | undefined, isWaitingList?: boolean | undefined, queries?: Types.JsQuery[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function searchAppointmentsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id, ids, from, to, eventTypes, subtenants, tags, visitTypes, patients, visitStatuses, resourceIds, placesIds, specialConditionsIds, doctorIds, isWithoutResources, isWithoutCanceledVisits, isWaitingList, queries, values, offset, limit, sortBy, sortOrder,  } = params[0] as SearchAppointmentsAppointmentEventsQueryParameters;

    return trimArrayEnd([
        'AppointmentEventsClient',
        'searchAppointments',
        id as any,
        ids as any,
        from as any,
        to as any,
        eventTypes as any,
        subtenants as any,
        tags as any,
        visitTypes as any,
        patients as any,
        visitStatuses as any,
        resourceIds as any,
        placesIds as any,
        specialConditionsIds as any,
        doctorIds as any,
        isWithoutResources as any,
        isWithoutCanceledVisits as any,
        isWaitingList as any,
        queries as any,
        values as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'AppointmentEventsClient',
        'searchAppointments',
        ...params
      ]);
  }
}
export function __searchAppointments(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.searchAppointments(
      context.queryKey[2] as number | null | undefined,       context.queryKey[3] as number[] | null | undefined,       context.queryKey[4] as Date | null | undefined,       context.queryKey[5] as Date | null | undefined,       context.queryKey[6] as Types.AppointmentType[] | null | undefined,       context.queryKey[7] as number[] | null | undefined,       context.queryKey[8] as number[] | null | undefined,       context.queryKey[9] as number[] | null | undefined,       context.queryKey[10] as number[] | null | undefined,       context.queryKey[11] as Types.AppointmentStatusCodes[] | null | undefined,       context.queryKey[12] as number[] | null | undefined,       context.queryKey[13] as number[] | null | undefined,       context.queryKey[14] as number[] | null | undefined,       context.queryKey[15] as number[] | null | undefined,       context.queryKey[16] as boolean | null | undefined,       context.queryKey[17] as boolean | undefined,       context.queryKey[18] as boolean | undefined,       context.queryKey[19] as Types.JsQuery[] | null | undefined,       context.queryKey[20] as { [key: string]: string[]; } | null | undefined,       context.queryKey[21] as number | null | undefined,       context.queryKey[22] as number | null | undefined,       context.queryKey[23] as string | null | undefined,       context.queryKey[24] as Types.SortOrder | undefined,axiosConfig    );
}

export function useSearchAppointmentsQuery<TSelectData = Types.AppointmentEventDto[], TError = unknown>(dto: SearchAppointmentsAppointmentEventsQueryParameters, options?: Omit<UseQueryOptions<Types.AppointmentEventDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param id (optional) 
 * @param ids (optional) 
 * @param from (optional) 
 * @param to (optional) 
 * @param eventTypes (optional) 
 * @param subtenants (optional) 
 * @param tags (optional) 
 * @param visitTypes (optional) 
 * @param patients (optional) 
 * @param visitStatuses (optional) 
 * @param resourceIds (optional) At least one Resource must be present in the Appointment to pass the filter.
You could actually put PlacesIds, SpecialConditionsIds and DoctorIds in this field
and you will receive all visits that have at least one Resource out of them.
This is useful for ResourceView
 * @param placesIds (optional) At least one Place is needed to be present in the Appointment
 * @param specialConditionsIds (optional) At least one SpecialCondition is needed to be present in the Appointment
 * @param doctorIds (optional) At least one Doctor is needed to be present in the Appointment
 * @param isWithoutResources (optional) Includes/excludes visits without resources (makes sense only if ResourceIds is not empty)
 * @param isWithoutCanceledVisits (optional) If true, canceled visits are excluded
 * @param isWaitingList (optional) If true, only visits from waiting list are included
If false, visits from waiting list are excluded
 * @param queries (optional) Queries for additional data that should be returned from Backend so that Clients could calculate some custom Expressions
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useSearchAppointmentsQuery<TSelectData = Types.AppointmentEventDto[], TError = unknown>(id?: number | null | undefined, ids?: number[] | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, eventTypes?: Types.AppointmentType[] | null | undefined, subtenants?: number[] | null | undefined, tags?: number[] | null | undefined, visitTypes?: number[] | null | undefined, patients?: number[] | null | undefined, visitStatuses?: Types.AppointmentStatusCodes[] | null | undefined, resourceIds?: number[] | null | undefined, placesIds?: number[] | null | undefined, specialConditionsIds?: number[] | null | undefined, doctorIds?: number[] | null | undefined, isWithoutResources?: boolean | null | undefined, isWithoutCanceledVisits?: boolean | undefined, isWaitingList?: boolean | undefined, queries?: Types.JsQuery[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: Omit<UseQueryOptions<Types.AppointmentEventDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useSearchAppointmentsQuery<TSelectData = Types.AppointmentEventDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.AppointmentEventDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  let ids: any = undefined;
  let from: any = undefined;
  let to: any = undefined;
  let eventTypes: any = undefined;
  let subtenants: any = undefined;
  let tags: any = undefined;
  let visitTypes: any = undefined;
  let patients: any = undefined;
  let visitStatuses: any = undefined;
  let resourceIds: any = undefined;
  let placesIds: any = undefined;
  let specialConditionsIds: any = undefined;
  let doctorIds: any = undefined;
  let isWithoutResources: any = undefined;
  let isWithoutCanceledVisits: any = undefined;
  let isWaitingList: any = undefined;
  let queries: any = undefined;
  let values: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id, ids, from, to, eventTypes, subtenants, tags, visitTypes, patients, visitStatuses, resourceIds, placesIds, specialConditionsIds, doctorIds, isWithoutResources, isWithoutCanceledVisits, isWaitingList, queries, values, offset, limit, sortBy, sortOrder,  } = params[0] as SearchAppointmentsAppointmentEventsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, ids, from, to, eventTypes, subtenants, tags, visitTypes, patients, visitStatuses, resourceIds, placesIds, specialConditionsIds, doctorIds, isWithoutResources, isWithoutCanceledVisits, isWaitingList, queries, values, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.AppointmentEventDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __searchAppointments(context, axiosConfig) : __searchAppointments,
    queryKey: searchAppointmentsQueryKey(id, ids, from, to, eventTypes, subtenants, tags, visitTypes, patients, visitStatuses, resourceIds, placesIds, specialConditionsIds, doctorIds, isWithoutResources, isWithoutCanceledVisits, isWaitingList, queries, values, offset, limit, sortBy, sortOrder),
    ...searchAppointmentsDefaultOptions as unknown as Omit<UseQueryOptions<Types.AppointmentEventDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param id (optional) 
 * @param ids (optional) 
 * @param from (optional) 
 * @param to (optional) 
 * @param eventTypes (optional) 
 * @param subtenants (optional) 
 * @param tags (optional) 
 * @param visitTypes (optional) 
 * @param patients (optional) 
 * @param visitStatuses (optional) 
 * @param resourceIds (optional) At least one Resource must be present in the Appointment to pass the filter.
You could actually put PlacesIds, SpecialConditionsIds and DoctorIds in this field
and you will receive all visits that have at least one Resource out of them.
This is useful for ResourceView
 * @param placesIds (optional) At least one Place is needed to be present in the Appointment
 * @param specialConditionsIds (optional) At least one SpecialCondition is needed to be present in the Appointment
 * @param doctorIds (optional) At least one Doctor is needed to be present in the Appointment
 * @param isWithoutResources (optional) Includes/excludes visits without resources (makes sense only if ResourceIds is not empty)
 * @param isWithoutCanceledVisits (optional) If true, canceled visits are excluded
 * @param isWaitingList (optional) If true, only visits from waiting list are included
If false, visits from waiting list are excluded
 * @param queries (optional) Queries for additional data that should be returned from Backend so that Clients could calculate some custom Expressions
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setSearchAppointmentsData(queryClient: QueryClient, updater: (data: Types.AppointmentEventDto[] | undefined) => Types.AppointmentEventDto[], id?: number | null | undefined, ids?: number[] | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, eventTypes?: Types.AppointmentType[] | null | undefined, subtenants?: number[] | null | undefined, tags?: number[] | null | undefined, visitTypes?: number[] | null | undefined, patients?: number[] | null | undefined, visitStatuses?: Types.AppointmentStatusCodes[] | null | undefined, resourceIds?: number[] | null | undefined, placesIds?: number[] | null | undefined, specialConditionsIds?: number[] | null | undefined, doctorIds?: number[] | null | undefined, isWithoutResources?: boolean | null | undefined, isWithoutCanceledVisits?: boolean | undefined, isWaitingList?: boolean | undefined, queries?: Types.JsQuery[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(searchAppointmentsQueryKey(id, ids, from, to, eventTypes, subtenants, tags, visitTypes, patients, visitStatuses, resourceIds, placesIds, specialConditionsIds, doctorIds, isWithoutResources, isWithoutCanceledVisits, isWaitingList, queries, values, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * @param id (optional) 
 * @param ids (optional) 
 * @param from (optional) 
 * @param to (optional) 
 * @param eventTypes (optional) 
 * @param subtenants (optional) 
 * @param tags (optional) 
 * @param visitTypes (optional) 
 * @param patients (optional) 
 * @param visitStatuses (optional) 
 * @param resourceIds (optional) At least one Resource must be present in the Appointment to pass the filter.
You could actually put PlacesIds, SpecialConditionsIds and DoctorIds in this field
and you will receive all visits that have at least one Resource out of them.
This is useful for ResourceView
 * @param placesIds (optional) At least one Place is needed to be present in the Appointment
 * @param specialConditionsIds (optional) At least one SpecialCondition is needed to be present in the Appointment
 * @param doctorIds (optional) At least one Doctor is needed to be present in the Appointment
 * @param isWithoutResources (optional) Includes/excludes visits without resources (makes sense only if ResourceIds is not empty)
 * @param isWithoutCanceledVisits (optional) If true, canceled visits are excluded
 * @param isWaitingList (optional) If true, only visits from waiting list are included
If false, visits from waiting list are excluded
 * @param queries (optional) Queries for additional data that should be returned from Backend so that Clients could calculate some custom Expressions
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setSearchAppointmentsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.AppointmentEventDto[] | undefined) => Types.AppointmentEventDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function searchAppointmentsWithResourceOccupationUrl(id?: number | null | undefined, ids?: number[] | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, eventTypes?: Types.AppointmentType[] | null | undefined, subtenants?: number[] | null | undefined, tags?: number[] | null | undefined, visitTypes?: number[] | null | undefined, patients?: number[] | null | undefined, visitStatuses?: Types.AppointmentStatusCodes[] | null | undefined, resourceIds?: number[] | null | undefined, placesIds?: number[] | null | undefined, specialConditionsIds?: number[] | null | undefined, doctorIds?: number[] | null | undefined, isWithoutResources?: boolean | null | undefined, isWithoutCanceledVisits?: boolean | undefined, isWaitingList?: boolean | undefined, queries?: Types.JsQuery[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/appointments/resource-occupation?";
if (id !== undefined && id !== null)
    url_ += "Id=" + encodeURIComponent("" + id) + "&";
if (ids !== undefined && ids !== null)
    ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
if (from !== undefined && from !== null)
    url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
if (to !== undefined && to !== null)
    url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
if (eventTypes !== undefined && eventTypes !== null)
    eventTypes && eventTypes.forEach(item => { url_ += "EventTypes=" + encodeURIComponent("" + item) + "&"; });
if (subtenants !== undefined && subtenants !== null)
    subtenants && subtenants.forEach(item => { url_ += "Subtenants=" + encodeURIComponent("" + item) + "&"; });
if (tags !== undefined && tags !== null)
    tags && tags.forEach(item => { url_ += "Tags=" + encodeURIComponent("" + item) + "&"; });
if (visitTypes !== undefined && visitTypes !== null)
    visitTypes && visitTypes.forEach(item => { url_ += "VisitTypes=" + encodeURIComponent("" + item) + "&"; });
if (patients !== undefined && patients !== null)
    patients && patients.forEach(item => { url_ += "Patients=" + encodeURIComponent("" + item) + "&"; });
if (visitStatuses !== undefined && visitStatuses !== null)
    visitStatuses && visitStatuses.forEach(item => { url_ += "VisitStatuses=" + encodeURIComponent("" + item) + "&"; });
if (resourceIds !== undefined && resourceIds !== null)
    resourceIds && resourceIds.forEach(item => { url_ += "ResourceIds=" + encodeURIComponent("" + item) + "&"; });
if (placesIds !== undefined && placesIds !== null)
    placesIds && placesIds.forEach(item => { url_ += "PlacesIds=" + encodeURIComponent("" + item) + "&"; });
if (specialConditionsIds !== undefined && specialConditionsIds !== null)
    specialConditionsIds && specialConditionsIds.forEach(item => { url_ += "SpecialConditionsIds=" + encodeURIComponent("" + item) + "&"; });
if (doctorIds !== undefined && doctorIds !== null)
    doctorIds && doctorIds.forEach(item => { url_ += "DoctorIds=" + encodeURIComponent("" + item) + "&"; });
if (isWithoutResources !== undefined && isWithoutResources !== null)
    url_ += "IsWithoutResources=" + encodeURIComponent("" + isWithoutResources) + "&";
if (isWithoutCanceledVisits === null)
    throw new Error("The parameter 'isWithoutCanceledVisits' cannot be null.");
else if (isWithoutCanceledVisits !== undefined)
    url_ += "IsWithoutCanceledVisits=" + encodeURIComponent("" + isWithoutCanceledVisits) + "&";
if (isWaitingList === null)
    throw new Error("The parameter 'isWaitingList' cannot be null.");
else if (isWaitingList !== undefined)
    url_ += "IsWaitingList=" + encodeURIComponent("" + isWaitingList) + "&";
if (queries !== undefined && queries !== null)
    queries && queries.forEach((item, index) => {
        for (let attr in item)
			if (item.hasOwnProperty(attr)) {
				url_ += "Queries[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
			}
    });
if (values !== undefined && values !== null)
    values && Object.keys(values).forEach(key => { url_ += encodeURIComponent(key) +"=" + encodeURIComponent("" + values[key]) + "&"; });
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let searchAppointmentsWithResourceOccupationDefaultOptions: Omit<UseQueryOptions<Types.AppointmentResourceOccupationDto[], unknown, Types.AppointmentResourceOccupationDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.AppointmentResourceOccupationDto[], unknown, Types.AppointmentResourceOccupationDto[]>, 'queryFn'>> = {
};
export function getSearchAppointmentsWithResourceOccupationDefaultOptions() {
  return searchAppointmentsWithResourceOccupationDefaultOptions;
};
export function setSearchAppointmentsWithResourceOccupationDefaultOptions(options: typeof searchAppointmentsWithResourceOccupationDefaultOptions) {
  searchAppointmentsWithResourceOccupationDefaultOptions = options;
}

export function searchAppointmentsWithResourceOccupationQueryKey(dto: SearchAppointmentsWithResourceOccupationAppointmentEventsQueryParameters): QueryKey;
export function searchAppointmentsWithResourceOccupationQueryKey(id?: number | null | undefined, ids?: number[] | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, eventTypes?: Types.AppointmentType[] | null | undefined, subtenants?: number[] | null | undefined, tags?: number[] | null | undefined, visitTypes?: number[] | null | undefined, patients?: number[] | null | undefined, visitStatuses?: Types.AppointmentStatusCodes[] | null | undefined, resourceIds?: number[] | null | undefined, placesIds?: number[] | null | undefined, specialConditionsIds?: number[] | null | undefined, doctorIds?: number[] | null | undefined, isWithoutResources?: boolean | null | undefined, isWithoutCanceledVisits?: boolean | undefined, isWaitingList?: boolean | undefined, queries?: Types.JsQuery[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function searchAppointmentsWithResourceOccupationQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id, ids, from, to, eventTypes, subtenants, tags, visitTypes, patients, visitStatuses, resourceIds, placesIds, specialConditionsIds, doctorIds, isWithoutResources, isWithoutCanceledVisits, isWaitingList, queries, values, offset, limit, sortBy, sortOrder,  } = params[0] as SearchAppointmentsWithResourceOccupationAppointmentEventsQueryParameters;

    return trimArrayEnd([
        'AppointmentEventsClient',
        'searchAppointmentsWithResourceOccupation',
        id as any,
        ids as any,
        from as any,
        to as any,
        eventTypes as any,
        subtenants as any,
        tags as any,
        visitTypes as any,
        patients as any,
        visitStatuses as any,
        resourceIds as any,
        placesIds as any,
        specialConditionsIds as any,
        doctorIds as any,
        isWithoutResources as any,
        isWithoutCanceledVisits as any,
        isWaitingList as any,
        queries as any,
        values as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'AppointmentEventsClient',
        'searchAppointmentsWithResourceOccupation',
        ...params
      ]);
  }
}
export function __searchAppointmentsWithResourceOccupation(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.searchAppointmentsWithResourceOccupation(
      context.queryKey[2] as number | null | undefined,       context.queryKey[3] as number[] | null | undefined,       context.queryKey[4] as Date | null | undefined,       context.queryKey[5] as Date | null | undefined,       context.queryKey[6] as Types.AppointmentType[] | null | undefined,       context.queryKey[7] as number[] | null | undefined,       context.queryKey[8] as number[] | null | undefined,       context.queryKey[9] as number[] | null | undefined,       context.queryKey[10] as number[] | null | undefined,       context.queryKey[11] as Types.AppointmentStatusCodes[] | null | undefined,       context.queryKey[12] as number[] | null | undefined,       context.queryKey[13] as number[] | null | undefined,       context.queryKey[14] as number[] | null | undefined,       context.queryKey[15] as number[] | null | undefined,       context.queryKey[16] as boolean | null | undefined,       context.queryKey[17] as boolean | undefined,       context.queryKey[18] as boolean | undefined,       context.queryKey[19] as Types.JsQuery[] | null | undefined,       context.queryKey[20] as { [key: string]: string[]; } | null | undefined,       context.queryKey[21] as number | null | undefined,       context.queryKey[22] as number | null | undefined,       context.queryKey[23] as string | null | undefined,       context.queryKey[24] as Types.SortOrder | undefined,axiosConfig    );
}

export function useSearchAppointmentsWithResourceOccupationQuery<TSelectData = Types.AppointmentResourceOccupationDto[], TError = unknown>(dto: SearchAppointmentsWithResourceOccupationAppointmentEventsQueryParameters, options?: Omit<UseQueryOptions<Types.AppointmentResourceOccupationDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Search for appointments in all subtenants (even if they are unavailable to current user)
and return anonymized information about these appointments (start date, end date and occupied resources)
 * @param id (optional) 
 * @param ids (optional) 
 * @param from (optional) 
 * @param to (optional) 
 * @param eventTypes (optional) 
 * @param subtenants (optional) 
 * @param tags (optional) 
 * @param visitTypes (optional) 
 * @param patients (optional) 
 * @param visitStatuses (optional) 
 * @param resourceIds (optional) At least one Resource must be present in the Appointment to pass the filter.
You could actually put PlacesIds, SpecialConditionsIds and DoctorIds in this field
and you will receive all visits that have at least one Resource out of them.
This is useful for ResourceView
 * @param placesIds (optional) At least one Place is needed to be present in the Appointment
 * @param specialConditionsIds (optional) At least one SpecialCondition is needed to be present in the Appointment
 * @param doctorIds (optional) At least one Doctor is needed to be present in the Appointment
 * @param isWithoutResources (optional) Includes/excludes visits without resources (makes sense only if ResourceIds is not empty)
 * @param isWithoutCanceledVisits (optional) If true, canceled visits are excluded
 * @param isWaitingList (optional) If true, only visits from waiting list are included
If false, visits from waiting list are excluded
 * @param queries (optional) Queries for additional data that should be returned from Backend so that Clients could calculate some custom Expressions
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useSearchAppointmentsWithResourceOccupationQuery<TSelectData = Types.AppointmentResourceOccupationDto[], TError = unknown>(id?: number | null | undefined, ids?: number[] | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, eventTypes?: Types.AppointmentType[] | null | undefined, subtenants?: number[] | null | undefined, tags?: number[] | null | undefined, visitTypes?: number[] | null | undefined, patients?: number[] | null | undefined, visitStatuses?: Types.AppointmentStatusCodes[] | null | undefined, resourceIds?: number[] | null | undefined, placesIds?: number[] | null | undefined, specialConditionsIds?: number[] | null | undefined, doctorIds?: number[] | null | undefined, isWithoutResources?: boolean | null | undefined, isWithoutCanceledVisits?: boolean | undefined, isWaitingList?: boolean | undefined, queries?: Types.JsQuery[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: Omit<UseQueryOptions<Types.AppointmentResourceOccupationDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useSearchAppointmentsWithResourceOccupationQuery<TSelectData = Types.AppointmentResourceOccupationDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.AppointmentResourceOccupationDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  let ids: any = undefined;
  let from: any = undefined;
  let to: any = undefined;
  let eventTypes: any = undefined;
  let subtenants: any = undefined;
  let tags: any = undefined;
  let visitTypes: any = undefined;
  let patients: any = undefined;
  let visitStatuses: any = undefined;
  let resourceIds: any = undefined;
  let placesIds: any = undefined;
  let specialConditionsIds: any = undefined;
  let doctorIds: any = undefined;
  let isWithoutResources: any = undefined;
  let isWithoutCanceledVisits: any = undefined;
  let isWaitingList: any = undefined;
  let queries: any = undefined;
  let values: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id, ids, from, to, eventTypes, subtenants, tags, visitTypes, patients, visitStatuses, resourceIds, placesIds, specialConditionsIds, doctorIds, isWithoutResources, isWithoutCanceledVisits, isWaitingList, queries, values, offset, limit, sortBy, sortOrder,  } = params[0] as SearchAppointmentsWithResourceOccupationAppointmentEventsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, ids, from, to, eventTypes, subtenants, tags, visitTypes, patients, visitStatuses, resourceIds, placesIds, specialConditionsIds, doctorIds, isWithoutResources, isWithoutCanceledVisits, isWaitingList, queries, values, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.AppointmentResourceOccupationDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __searchAppointmentsWithResourceOccupation(context, axiosConfig) : __searchAppointmentsWithResourceOccupation,
    queryKey: searchAppointmentsWithResourceOccupationQueryKey(id, ids, from, to, eventTypes, subtenants, tags, visitTypes, patients, visitStatuses, resourceIds, placesIds, specialConditionsIds, doctorIds, isWithoutResources, isWithoutCanceledVisits, isWaitingList, queries, values, offset, limit, sortBy, sortOrder),
    ...searchAppointmentsWithResourceOccupationDefaultOptions as unknown as Omit<UseQueryOptions<Types.AppointmentResourceOccupationDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Search for appointments in all subtenants (even if they are unavailable to current user)
and return anonymized information about these appointments (start date, end date and occupied resources)
 * @param id (optional) 
 * @param ids (optional) 
 * @param from (optional) 
 * @param to (optional) 
 * @param eventTypes (optional) 
 * @param subtenants (optional) 
 * @param tags (optional) 
 * @param visitTypes (optional) 
 * @param patients (optional) 
 * @param visitStatuses (optional) 
 * @param resourceIds (optional) At least one Resource must be present in the Appointment to pass the filter.
You could actually put PlacesIds, SpecialConditionsIds and DoctorIds in this field
and you will receive all visits that have at least one Resource out of them.
This is useful for ResourceView
 * @param placesIds (optional) At least one Place is needed to be present in the Appointment
 * @param specialConditionsIds (optional) At least one SpecialCondition is needed to be present in the Appointment
 * @param doctorIds (optional) At least one Doctor is needed to be present in the Appointment
 * @param isWithoutResources (optional) Includes/excludes visits without resources (makes sense only if ResourceIds is not empty)
 * @param isWithoutCanceledVisits (optional) If true, canceled visits are excluded
 * @param isWaitingList (optional) If true, only visits from waiting list are included
If false, visits from waiting list are excluded
 * @param queries (optional) Queries for additional data that should be returned from Backend so that Clients could calculate some custom Expressions
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setSearchAppointmentsWithResourceOccupationData(queryClient: QueryClient, updater: (data: Types.AppointmentResourceOccupationDto[] | undefined) => Types.AppointmentResourceOccupationDto[], id?: number | null | undefined, ids?: number[] | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, eventTypes?: Types.AppointmentType[] | null | undefined, subtenants?: number[] | null | undefined, tags?: number[] | null | undefined, visitTypes?: number[] | null | undefined, patients?: number[] | null | undefined, visitStatuses?: Types.AppointmentStatusCodes[] | null | undefined, resourceIds?: number[] | null | undefined, placesIds?: number[] | null | undefined, specialConditionsIds?: number[] | null | undefined, doctorIds?: number[] | null | undefined, isWithoutResources?: boolean | null | undefined, isWithoutCanceledVisits?: boolean | undefined, isWaitingList?: boolean | undefined, queries?: Types.JsQuery[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(searchAppointmentsWithResourceOccupationQueryKey(id, ids, from, to, eventTypes, subtenants, tags, visitTypes, patients, visitStatuses, resourceIds, placesIds, specialConditionsIds, doctorIds, isWithoutResources, isWithoutCanceledVisits, isWaitingList, queries, values, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * Search for appointments in all subtenants (even if they are unavailable to current user)
and return anonymized information about these appointments (start date, end date and occupied resources)
 * @param id (optional) 
 * @param ids (optional) 
 * @param from (optional) 
 * @param to (optional) 
 * @param eventTypes (optional) 
 * @param subtenants (optional) 
 * @param tags (optional) 
 * @param visitTypes (optional) 
 * @param patients (optional) 
 * @param visitStatuses (optional) 
 * @param resourceIds (optional) At least one Resource must be present in the Appointment to pass the filter.
You could actually put PlacesIds, SpecialConditionsIds and DoctorIds in this field
and you will receive all visits that have at least one Resource out of them.
This is useful for ResourceView
 * @param placesIds (optional) At least one Place is needed to be present in the Appointment
 * @param specialConditionsIds (optional) At least one SpecialCondition is needed to be present in the Appointment
 * @param doctorIds (optional) At least one Doctor is needed to be present in the Appointment
 * @param isWithoutResources (optional) Includes/excludes visits without resources (makes sense only if ResourceIds is not empty)
 * @param isWithoutCanceledVisits (optional) If true, canceled visits are excluded
 * @param isWaitingList (optional) If true, only visits from waiting list are included
If false, visits from waiting list are excluded
 * @param queries (optional) Queries for additional data that should be returned from Backend so that Clients could calculate some custom Expressions
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setSearchAppointmentsWithResourceOccupationDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.AppointmentResourceOccupationDto[] | undefined) => Types.AppointmentResourceOccupationDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function cancelVisitUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/appointments/visits/{id}/cancel";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function cancelVisitMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'AppointmentEventsClient',
      'cancelVisit',
      id as any,
    ]);
}

export function useCancelVisitMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = cancelVisitMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.cancelVisit(id),
    mutationKey: key,
  });
}
  
type CancelVisit__MutationParameters = CancelVisitAppointmentEventsQueryParameters

export function useCancelVisitMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, CancelVisit__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: CancelVisitAppointmentEventsQueryParameters}): UseMutationResult<void, unknown, CancelVisit__MutationParameters, TContext> {
  const key = cancelVisitMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: CancelVisit__MutationParameters) => Client.cancelVisit(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function confirmVisitUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/appointments/visits/{id}/confirm";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function confirmVisitMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'AppointmentEventsClient',
      'confirmVisit',
      id as any,
    ]);
}

export function useConfirmVisitMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = confirmVisitMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.confirmVisit(id),
    mutationKey: key,
  });
}
  
type ConfirmVisit__MutationParameters = ConfirmVisitAppointmentEventsQueryParameters

export function useConfirmVisitMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, ConfirmVisit__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: ConfirmVisitAppointmentEventsQueryParameters}): UseMutationResult<void, unknown, ConfirmVisit__MutationParameters, TContext> {
  const key = confirmVisitMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: ConfirmVisit__MutationParameters) => Client.confirmVisit(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function completeVisitUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/appointments/visits/{id}/complete";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function completeVisitMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'AppointmentEventsClient',
      'completeVisit',
      id as any,
    ]);
}

export function useCompleteVisitMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = completeVisitMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.completeVisit(id),
    mutationKey: key,
  });
}
  
type CompleteVisit__MutationParameters = CompleteVisitAppointmentEventsQueryParameters

export function useCompleteVisitMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, CompleteVisit__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: CompleteVisitAppointmentEventsQueryParameters}): UseMutationResult<void, unknown, CompleteVisit__MutationParameters, TContext> {
  const key = completeVisitMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: CompleteVisit__MutationParameters) => Client.completeVisit(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function createMeetingUrl(): string {
  let url_ = getBaseUrl() + "/api/appointments/meetings";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMeetingMutationKey(): MutationKey {
  return trimArrayEnd([
      'AppointmentEventsClient',
      'createMeeting',
    ]);
}

export function useCreateMeetingMutation<TContext>(options?: Omit<UseMutationOptions<Types.MeetingDto, unknown, Types.CreateMeetingDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.MeetingDto, unknown, Types.CreateMeetingDto, TContext> {
  const key = createMeetingMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (createMeetingDto: Types.CreateMeetingDto) => Client.createMeeting(createMeetingDto),
    mutationKey: key,
  });
}
  
export function findFreeTimeSlotUrl(patientId?: number | undefined, visitTypeId?: number | undefined, start?: Date | undefined, durationInSeconds?: number | undefined, timeStepInSeconds?: number | undefined, searchDirection?: Types.SearchDirection | undefined, skipCurrentDay?: boolean | undefined, isParticularTime?: boolean | undefined, searchIntervalForwardInDays?: number | undefined, searchIntervalBackwardInDays?: number | undefined, visitId?: number | null | undefined, resourceIds?: number[] | null | undefined): string {
  let url_ = getBaseUrl() + "/api/appointments/free-time-slot?";
if (patientId === null)
    throw new Error("The parameter 'patientId' cannot be null.");
else if (patientId !== undefined)
    url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
if (visitTypeId === null)
    throw new Error("The parameter 'visitTypeId' cannot be null.");
else if (visitTypeId !== undefined)
    url_ += "VisitTypeId=" + encodeURIComponent("" + visitTypeId) + "&";
if (start === null)
    throw new Error("The parameter 'start' cannot be null.");
else if (start !== undefined)
    url_ += "Start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
if (durationInSeconds === null)
    throw new Error("The parameter 'durationInSeconds' cannot be null.");
else if (durationInSeconds !== undefined)
    url_ += "DurationInSeconds=" + encodeURIComponent("" + durationInSeconds) + "&";
if (timeStepInSeconds === null)
    throw new Error("The parameter 'timeStepInSeconds' cannot be null.");
else if (timeStepInSeconds !== undefined)
    url_ += "TimeStepInSeconds=" + encodeURIComponent("" + timeStepInSeconds) + "&";
if (searchDirection === null)
    throw new Error("The parameter 'searchDirection' cannot be null.");
else if (searchDirection !== undefined)
    url_ += "SearchDirection=" + encodeURIComponent("" + searchDirection) + "&";
if (skipCurrentDay === null)
    throw new Error("The parameter 'skipCurrentDay' cannot be null.");
else if (skipCurrentDay !== undefined)
    url_ += "SkipCurrentDay=" + encodeURIComponent("" + skipCurrentDay) + "&";
if (isParticularTime === null)
    throw new Error("The parameter 'isParticularTime' cannot be null.");
else if (isParticularTime !== undefined)
    url_ += "IsParticularTime=" + encodeURIComponent("" + isParticularTime) + "&";
if (searchIntervalForwardInDays === null)
    throw new Error("The parameter 'searchIntervalForwardInDays' cannot be null.");
else if (searchIntervalForwardInDays !== undefined)
    url_ += "SearchIntervalForwardInDays=" + encodeURIComponent("" + searchIntervalForwardInDays) + "&";
if (searchIntervalBackwardInDays === null)
    throw new Error("The parameter 'searchIntervalBackwardInDays' cannot be null.");
else if (searchIntervalBackwardInDays !== undefined)
    url_ += "SearchIntervalBackwardInDays=" + encodeURIComponent("" + searchIntervalBackwardInDays) + "&";
if (visitId !== undefined && visitId !== null)
    url_ += "VisitId=" + encodeURIComponent("" + visitId) + "&";
if (resourceIds !== undefined && resourceIds !== null)
    resourceIds && resourceIds.forEach(item => { url_ += "ResourceIds=" + encodeURIComponent("" + item) + "&"; });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let findFreeTimeSlotDefaultOptions: Omit<UseQueryOptions<Types.FindFreeTimeSlotResultDto, unknown, Types.FindFreeTimeSlotResultDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.FindFreeTimeSlotResultDto, unknown, Types.FindFreeTimeSlotResultDto>, 'queryFn'>> = {
};
export function getFindFreeTimeSlotDefaultOptions() {
  return findFreeTimeSlotDefaultOptions;
};
export function setFindFreeTimeSlotDefaultOptions(options: typeof findFreeTimeSlotDefaultOptions) {
  findFreeTimeSlotDefaultOptions = options;
}

export function findFreeTimeSlotQueryKey(dto: FindFreeTimeSlotAppointmentEventsQueryParameters): QueryKey;
export function findFreeTimeSlotQueryKey(patientId?: number | undefined, visitTypeId?: number | undefined, start?: Date | undefined, durationInSeconds?: number | undefined, timeStepInSeconds?: number | undefined, searchDirection?: Types.SearchDirection | undefined, skipCurrentDay?: boolean | undefined, isParticularTime?: boolean | undefined, searchIntervalForwardInDays?: number | undefined, searchIntervalBackwardInDays?: number | undefined, visitId?: number | null | undefined, resourceIds?: number[] | null | undefined): QueryKey;
export function findFreeTimeSlotQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { patientId, visitTypeId, start, durationInSeconds, timeStepInSeconds, searchDirection, skipCurrentDay, isParticularTime, searchIntervalForwardInDays, searchIntervalBackwardInDays, visitId, resourceIds,  } = params[0] as FindFreeTimeSlotAppointmentEventsQueryParameters;

    return trimArrayEnd([
        'AppointmentEventsClient',
        'findFreeTimeSlot',
        patientId as any,
        visitTypeId as any,
        start as any,
        durationInSeconds as any,
        timeStepInSeconds as any,
        searchDirection as any,
        skipCurrentDay as any,
        isParticularTime as any,
        searchIntervalForwardInDays as any,
        searchIntervalBackwardInDays as any,
        visitId as any,
        resourceIds as any,
      ]);
  } else {
    return trimArrayEnd([
        'AppointmentEventsClient',
        'findFreeTimeSlot',
        ...params
      ]);
  }
}
export function __findFreeTimeSlot(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.findFreeTimeSlot(
      context.queryKey[2] as number | undefined,       context.queryKey[3] as number | undefined,       context.queryKey[4] as Date | undefined,       context.queryKey[5] as number | undefined,       context.queryKey[6] as number | undefined,       context.queryKey[7] as Types.SearchDirection | undefined,       context.queryKey[8] as boolean | undefined,       context.queryKey[9] as boolean | undefined,       context.queryKey[10] as number | undefined,       context.queryKey[11] as number | undefined,       context.queryKey[12] as number | null | undefined,       context.queryKey[13] as number[] | null | undefined,axiosConfig    );
}

export function useFindFreeTimeSlotQuery<TSelectData = Types.FindFreeTimeSlotResultDto, TError = unknown>(dto: FindFreeTimeSlotAppointmentEventsQueryParameters, options?: Omit<UseQueryOptions<Types.FindFreeTimeSlotResultDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useFindFreeTimeSlotQuery<TSelectData = Types.FindFreeTimeSlotResultDto, TError = unknown>(patientId?: number | undefined, visitTypeId?: number | undefined, start?: Date | undefined, durationInSeconds?: number | undefined, timeStepInSeconds?: number | undefined, searchDirection?: Types.SearchDirection | undefined, skipCurrentDay?: boolean | undefined, isParticularTime?: boolean | undefined, searchIntervalForwardInDays?: number | undefined, searchIntervalBackwardInDays?: number | undefined, visitId?: number | null | undefined, resourceIds?: number[] | null | undefined, options?: Omit<UseQueryOptions<Types.FindFreeTimeSlotResultDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useFindFreeTimeSlotQuery<TSelectData = Types.FindFreeTimeSlotResultDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.FindFreeTimeSlotResultDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let patientId: any = undefined;
  let visitTypeId: any = undefined;
  let start: any = undefined;
  let durationInSeconds: any = undefined;
  let timeStepInSeconds: any = undefined;
  let searchDirection: any = undefined;
  let skipCurrentDay: any = undefined;
  let isParticularTime: any = undefined;
  let searchIntervalForwardInDays: any = undefined;
  let searchIntervalBackwardInDays: any = undefined;
  let visitId: any = undefined;
  let resourceIds: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ patientId, visitTypeId, start, durationInSeconds, timeStepInSeconds, searchDirection, skipCurrentDay, isParticularTime, searchIntervalForwardInDays, searchIntervalBackwardInDays, visitId, resourceIds,  } = params[0] as FindFreeTimeSlotAppointmentEventsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [patientId, visitTypeId, start, durationInSeconds, timeStepInSeconds, searchDirection, skipCurrentDay, isParticularTime, searchIntervalForwardInDays, searchIntervalBackwardInDays, visitId, resourceIds, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.FindFreeTimeSlotResultDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __findFreeTimeSlot(context, axiosConfig) : __findFreeTimeSlot,
    queryKey: findFreeTimeSlotQueryKey(patientId, visitTypeId, start, durationInSeconds, timeStepInSeconds, searchDirection, skipCurrentDay, isParticularTime, searchIntervalForwardInDays, searchIntervalBackwardInDays, visitId, resourceIds),
    ...findFreeTimeSlotDefaultOptions as unknown as Omit<UseQueryOptions<Types.FindFreeTimeSlotResultDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setFindFreeTimeSlotData(queryClient: QueryClient, updater: (data: Types.FindFreeTimeSlotResultDto | undefined) => Types.FindFreeTimeSlotResultDto, patientId?: number | undefined, visitTypeId?: number | undefined, start?: Date | undefined, durationInSeconds?: number | undefined, timeStepInSeconds?: number | undefined, searchDirection?: Types.SearchDirection | undefined, skipCurrentDay?: boolean | undefined, isParticularTime?: boolean | undefined, searchIntervalForwardInDays?: number | undefined, searchIntervalBackwardInDays?: number | undefined, visitId?: number | null | undefined, resourceIds?: number[] | null | undefined) {
  queryClient.setQueryData(findFreeTimeSlotQueryKey(patientId, visitTypeId, start, durationInSeconds, timeStepInSeconds, searchDirection, skipCurrentDay, isParticularTime, searchIntervalForwardInDays, searchIntervalBackwardInDays, visitId, resourceIds),
    updater
  );
}

export function setFindFreeTimeSlotDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.FindFreeTimeSlotResultDto | undefined) => Types.FindFreeTimeSlotResultDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function getAbsenceUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/appointments/absences/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getAbsenceDefaultOptions: Omit<UseQueryOptions<Types.AbsenceDto, unknown, Types.AbsenceDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.AbsenceDto, unknown, Types.AbsenceDto>, 'queryFn'>> = {
};
export function getGetAbsenceDefaultOptions() {
  return getAbsenceDefaultOptions;
};
export function setGetAbsenceDefaultOptions(options: typeof getAbsenceDefaultOptions) {
  getAbsenceDefaultOptions = options;
}

export function getAbsenceQueryKey(id: number): QueryKey;
export function getAbsenceQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetAbsenceAppointmentEventsQueryParameters;

    return trimArrayEnd([
        'AppointmentEventsClient',
        'getAbsence',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'AppointmentEventsClient',
        'getAbsence',
        ...params
      ]);
  }
}
export function __getAbsence(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getAbsence(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetAbsenceQuery<TSelectData = Types.AbsenceDto, TError = unknown>(dto: GetAbsenceAppointmentEventsQueryParameters, options?: Omit<UseQueryOptions<Types.AbsenceDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetAbsenceQuery<TSelectData = Types.AbsenceDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.AbsenceDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetAbsenceQuery<TSelectData = Types.AbsenceDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.AbsenceDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetAbsenceAppointmentEventsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.AbsenceDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getAbsence(context, axiosConfig) : __getAbsence,
    queryKey: getAbsenceQueryKey(id),
    ...getAbsenceDefaultOptions as unknown as Omit<UseQueryOptions<Types.AbsenceDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetAbsenceData(queryClient: QueryClient, updater: (data: Types.AbsenceDto | undefined) => Types.AbsenceDto, id: number) {
  queryClient.setQueryData(getAbsenceQueryKey(id),
    updater
  );
}

export function setGetAbsenceDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.AbsenceDto | undefined) => Types.AbsenceDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchAbsenceUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/appointments/absences/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchAbsenceMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'AppointmentEventsClient',
      'patchAbsence',
      id as any,
    ]);
}

export function usePatchAbsenceMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.AbsenceDto, unknown, Types.PatchAbsenceDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.AbsenceDto, unknown, Types.PatchAbsenceDto, TContext> {
  const key = patchAbsenceMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (patchDto: Types.PatchAbsenceDto) => Client.patchAbsence(id, patchDto),
    mutationKey: key,
  });
}
  
type PatchAbsence__MutationParameters = PatchAbsenceAppointmentEventsQueryParameters & {
  patchDto: Types.PatchAbsenceDto;
}

export function usePatchAbsenceMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.AbsenceDto, unknown, PatchAbsence__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchAbsenceAppointmentEventsQueryParameters}): UseMutationResult<Types.AbsenceDto, unknown, PatchAbsence__MutationParameters, TContext> {
  const key = patchAbsenceMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PatchAbsence__MutationParameters) => Client.patchAbsence(data.id ?? options?.parameters?.id!, data.patchDto),
  mutationKey: key,
});
}
  
export function createAbsenceUrl(): string {
  let url_ = getBaseUrl() + "/api/appointments/absences";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createAbsenceMutationKey(): MutationKey {
  return trimArrayEnd([
      'AppointmentEventsClient',
      'createAbsence',
    ]);
}

export function useCreateAbsenceMutation<TContext>(options?: Omit<UseMutationOptions<Types.AbsenceDto, unknown, Types.CreateAbsenceDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.AbsenceDto, unknown, Types.CreateAbsenceDto, TContext> {
  const key = createAbsenceMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (createAbsenceDto: Types.CreateAbsenceDto) => Client.createAbsence(createAbsenceDto),
    mutationKey: key,
  });
}